import type { AnchorHTMLAttributes, DetailedHTMLProps, PropsWithChildren } from "react";

import { Link, type LinkProps } from "react-router";
import { twMerge } from "tailwind-merge";

/** Standard <a> tag with styling applied */
export function Anchor({
  children,
  className,
  ...props
}: PropsWithChildren<DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>>) {
  return (
    <a
      className={twMerge(
        "text-[hsl(from_currentcolor_h_s_calc((l+75)/2))] underline hover:text-[hsl(from_currentcolor_h_s_calc((l+50)/2))]",
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
}

/** <Link> tag with consistent styling applied */
export function AnchorLink({ children, className, ...props }: LinkProps) {
  return (
    <Link
      className={twMerge(
        "text-[hsl(from_currentcolor_h_s_calc((l+75)/2))] underline hover:text-[hsl(from_currentcolor_h_s_calc((l+50)/2))]",
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
}
